export enum LoginEnum {
  ERROR_INVALID_GRANT = 'invalid_grant',
  ERROR_TERMS_NOT_ACCEPTED = 'terms_not_accepted',
}
